import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './Background.scss'

const Background = ({ onClick, children, top, light }) => (
	<div
		styleName={light ? 'background-light' : 'background'}
		className={top ? styles.top : null}
		onClick={onClick}
	>
		{children}
	</div>
)

export default CSSModules(Background, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Overlay/Background.js